<template>
    <div class="flex flex-col gap-2">
        <UInputMenu
            v-model="picker"
            :search="search"
            placeholder="Search policy holders..."
            nullable
            size="lg"
            @update:model-value="onPick"
        />
        <div v-if="current.length" class="flex flex-col gap-1">
            <div
                v-for="p in current"
                :key="p"
                class="flex items-center justify-between gap-2 rounded-md bg-gray-50 px-2.5 py-1.5"
            >
                <span class="truncate text-sm text-gray-700" :title="p">{{ p }}</span>
                <UButton icon="i-ph-x-bold" size="2xs" color="gray" variant="ghost" :padded="false" class="shrink-0 p-0.5" @click="removeOne(p)" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()
const client = useSupabaseClient()

const picker = ref<any>(null)
const current = computed<string[]>(() => (Array.isArray(props.filter.value) ? props.filter.value : []))

function emitList(list: string[]) {
    emit('update:filter', { ...props.filter, value: list.length ? list : undefined, selected: list.length ? list : undefined })
}

function onPick(value: string | null) {
    if (!value) return
    if (!current.value.includes(value)) emitList([...current.value, value])
    nextTick(() => { picker.value = null })
}

function removeOne(value: string) {
    emitList(current.value.filter(v => v !== value))
}

async function search(q: string) {
    const { data, error } = await client
        .rpc('get_policy_holder_suggestions', { partial_name: q ?? '' } as never)
        .returns<{ policy_holder: string }[]>()
    if (error) return []
    return data.map(t => t.policy_holder).filter(p => !current.value.includes(p))
}
</script>
